import React, { useCallback } from "react";
import EnterpriseGridCommon from "../AgGrid/Ag-Grid";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useTranslation } from "react-i18next";
import { createTlogGridColumns } from "./tlog_grid_columns";
import { logDataHelperFunctions } from "../../helpers/logdata-helper";
import { tlogHelper } from "../../helpers/tlog/tlog-helper";
import { GlobalUnitEnum } from "../../helpers/unit-conversion";
import CommonLoader from "../Loaders/loader";

const TlogGrid = ({
  rows,
  loading,
  tableHeight,
  statusCalculationMethod,
  selectedRowKeys,
  showRowSelection,
  onRowSelected,
  station_number,
  hideColumnsStationZero,
  hasValidM500Data,
  isM500,
  // getRange,
  tableLimitData,
  rawTlogData,
  currentProject,
  isFromPQRTab = false,
}) => {
  const { t } = useTranslation();

  const showRangeColumns = [
    "volts",
    "current",
    "wireSpeed",
    "oscillationWidth",
    "trueEnergy",
    "heat",
    "travelSpeed",
  ];

  const getTableLimitColumnValue = (column) => {
    switch (column) {
      case "volts":
        return "volts";
      case "current":
        return "current";
      case "wireSpeed":
        return "wire_speed";
      case "trueEnergy":
        return "true_energy";
      case "oscillationWidth":
        return "oscillation_width";
      case "heat":
        return "heat";
      case "travelSpeed":
        return "travel_speed";
      default:
        return column;
    }
  };

  // Use shared getRangeDisplay function from tlogHelper
  const getRangeDisplay = useCallback(
    ({ tlogItem, limitData, reportColumns, column }) => {
      const globalUnit = currentProject?.globalUnit || GlobalUnitEnum.IMPERIAL;
      return tlogHelper.getRangeDisplay({
        tlogItem,
        limitData,
        reportColumns,
        column,
        globalUnit,
      });
    },
    [currentProject]
  );

  const columnDefs = useCallback(() => {
    return createTlogGridColumns(t, selectedRowKeys, statusCalculationMethod);
  }, [selectedRowKeys, statusCalculationMethod, t]);

  // Filter columns based on station number and other conditions
  let columnsFormatted = tlogHelper
    .mapTlogColumns(
      columnDefs(),
      logDataHelperFunctions.data360LiveGetReportColumns(currentProject),
      false,
      isM500
    )
    ?.filter((column) => {
      if (station_number === 0) {
        return !hideColumnsStationZero.includes(column.field);
      }
      return true;
    });

  // Additional column filtering logic
  columnsFormatted = columnsFormatted
    ?.filter((ite) => {
      if (
        !hasValidM500Data &&
        (ite.field === "headAngle" ||
          ite.field === "arcImpedance" ||
          ite.field === "pipe_name")
      ) {
        return null;
      }
      return ite;
    })
    ?.filter((ite) => ite != null)
    ?.map((column) => {
      return {
        ...column,
        headerName:
          showRangeColumns?.includes(column.field) && !isFromPQRTab
            ? column.headerName +
              " " +
              getRangeDisplay({
                tlogItem: rawTlogData?.[0],
                limitData: tableLimitData,
                reportColumns:
                  logDataHelperFunctions.data360LiveGetReportColumns(
                    currentProject
                  ),
                column: getTableLimitColumnValue(column.field),
              })?.showColor
            : column.headerName,
      };
    });

  return (
    <div
      className="ag-theme-alpine tlog-grid-container"
      style={{ width: "100%" }}
    >
      {loading ? (
        <div className="slogdata-loader">
          <CommonLoader />
        </div>
      ) : (
        <EnterpriseGridCommon
          isLoading={loading}
          rows={rows}
          columnDefs={columnsFormatted}
          exportFileName={"tlog"}
          heightValue={tableHeight}
          showRowSelection={showRowSelection}
          onRowSelected={onRowSelected}
        />
      )}
    </div>
  );
};

export default TlogGrid;
